const getDecimalValue = (value) => value && Number((parseFloat(value) / 100).toPrecision(4));

export default getDecimalValue;
